import React, { useContext } from 'react';
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

import { Context } from '../Wizard/WizardWrapper';

const ReactSelectField = ({
  name,
  options,
  isMulti = false,
  controlStyle = {},
}) => {
  const { setValue, watch, control } = useContext(Context);

  const handleChange = (event, fieldName) => {
    const eventTargetName =
      event.target !== undefined ? event.target.name : fieldName;
    const eventTargetValue =
      event.target !== undefined ? parseInt(event.target.value) : event;
    setValue(eventTargetName, eventTargetValue);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select
          options={options}
          isMulti={isMulti}
          onChange={(e) => {
            field.onChange(e);
            setValue(name, e, { shouldValidate: true });
            handleChange(e, name);
          }}
          value={watch(name)}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              minHeight: '3rem',
              borderRadius: '0.5rem',
              borderColor: '#B3B3B3',
              ...controlStyle,
            }),
          }}
          className={`${name} mb-3`}
        />
      )}
    />
  );
};

ReactSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  isMulti: PropTypes.bool,
  controlStyle: PropTypes.object,
};

export default ReactSelectField;
